(function () {
  'use strict';
  	angular.module('dcApp')
  	.filter('isNotEmptyObject', [function() { // Removed extra semicolon here
      return function(obj) {
        return angular.isObject(obj) && Object.keys(obj).length > 0;
      };
    }]);
})();
